import { render, staticRenderFns } from "./ConfirmOTP.vue?vue&type=template&id=491fc2d3&scoped=true&"
import script from "./ConfirmOTP.vue?vue&type=script&lang=js&"
export * from "./ConfirmOTP.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/authenticate/_confirm-otp.scss?vue&type=style&index=0&id=491fc2d3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491fc2d3",
  null
  
)

export default component.exports